import { r as registerInstance, h, H as Host, g as getElement } from './index-d4808923.js';
import { c as classesToString } from './utils-17533423.js';

const gravityIconCss = ":host{align-items:center;display:inline-flex;vertical-align:text-top}";
const GravityIconStyle0 = gravityIconCss;

const Icon = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.name = undefined;
        this.size = 'xx-small';
    }
    render() {
        const GravityIconTag = `gravity-icon-${this.name}`;
        return (h(Host, { key: 'c8e3d78d675c811790dbe587a31707bb3a99648a', "aria-hidden": "true" }, h(GravityIconTag, { key: 'a90ab9db98ae686a99f372554f9bebd36c4dd5ea', color: this.color, size: this.size })));
    }
};
Icon.style = GravityIconStyle0;

const gravityTextCss = ":host([clamp]){max-width:100%;min-width:0}.text{display:inherit;font-family:\"Bull\", Helvetica, sans-serif;font-variant-numeric:lining-nums tabular-nums;font-weight:400;overflow:inherit;text-decoration:inherit;text-overflow:inherit;font-feature-settings:\"liga\" on;font-feature-settings:\"liga\" on;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.text--size-x-large{font-size:32px;line-height:1.25}.text--size-large{font-size:24px;line-height:1.333333}.text--size-medium{font-size:20px;line-height:1.4}.text--size-small{font-size:16px;line-height:1.5}.text--size-x-small{font-size:14px;line-height:1.428571}.text--size-xx-small{font-size:12px;line-height:1.333333}.text--type-small{font-size:12px;line-height:1.333333}.text--type-singleline{font-size:14px;line-height:1.428571}.text--type-multiline{font-size:14px;line-height:1.428571}.text--weight-regular{font-weight:400}.text--weight-medium{font-weight:500}.text--weight-bold{font-weight:700}.text--clamp{display:block}.text--clamp-single{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text--clamp-multi{-webkit-box-orient:vertical;display:-webkit-box;-webkit-line-clamp:var(--gravity-text-clamp-length);overflow:hidden;}.text--color-dark{color:var(--gravity-text-color, #000F1E)}.text--color-dark-subtle{color:var(--gravity-text-color, rgba(0, 15, 30, 0.6))}.text--color-dark-muted{color:var(--gravity-text-color, rgba(0, 15, 30, 0.4))}.text--color-light{color:var(--gravity-text-color, #FFFFFF)}.text--color-light-subtle{color:var(--gravity-text-color, rgba(255, 255, 255, 0.6))}.text--color-light-muted{color:var(--gravity-text-color, rgba(255, 255, 255, 0.4))}.text--color-positive{color:var(--gravity-text-color, #159D48)}.text--color-negative{color:var(--gravity-text-color, #DB0A40)}.text--color-informative{color:var(--gravity-text-color, #FF9000)}.text--color-primary{color:var(--gravity-text-color, #1B6AEE)}.text--color-primary-lighter{color:var(--gravity-text-color, #3279F0)}.text--color-primary-darker{color:var(--gravity-text-color, #175ACA)}";
const GravityTextStyle0 = gravityTextCss;

const GravityText = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.clamp = undefined;
        this.color = 'dark';
        this.size = 'x-small';
        this.type = undefined;
        this.weight = 'regular';
    }
    isSingleLineClamp() {
        return this.clamp === 1;
    }
    isMultiLineClamp() {
        return this.clamp > 1;
    }
    render() {
        const classes = [
            `text`,
            // use type instead of size when defined for backward-compatibility
            this.type ? `text--type-${this.type}` : `text--size-${this.size}`,
            `text--weight-${this.weight}`,
            `text--color-${this.color}`,
            this.isSingleLineClamp() ? 'text--clamp text--clamp-single' : '',
            this.isMultiLineClamp() ? 'text--clamp text--clamp-multi' : '',
        ];
        return (h("span", { key: '732e234a826f1bb4ebb80af4816e53b72d944c3d', class: classesToString(classes), style: this.isMultiLineClamp() ? { '--gravity-text-clamp-length': `${this.clamp}` } : {} }, h("slot", { key: '1ce91b80ee7016c92f5ec4aaac757db9c0857c73' })));
    }
    get element() { return getElement(this); }
};
GravityText.style = GravityTextStyle0;

export { Icon as gravity_icon, GravityText as gravity_text };

//# sourceMappingURL=gravity-icon_2.entry.js.map